var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.091,
    height: 27.913,
    viewBox: "0 0 86.091 27.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#595959;}.b{fill:url(#a);}.c{fill:url(#b);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.225,
    cy: 0.088,
    r: 1.133,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#ffc800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#ff7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#ff4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.024,
    cy: 0.145,
    r: 1.392,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#00b0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#01a5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#0292cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0377ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#0455a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054696"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-662 -651.113)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(661.921 650.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.568,20.609a1.253,1.253,0,0,1-.574.984L12.9,28.011a1.28,1.28,0,0,1-1.149,0L.653,21.593a1.251,1.251,0,0,1-.574-.984V7.772a1.253,1.253,0,0,1,.574-.984L11.749.37A1.28,1.28,0,0,1,12.9.37l11.1,6.418a1.251,1.251,0,0,1,.574.984ZM86.17,8.7H76.238v2.376h3.567V21.229h2.812V11.072h3.553Zm-45.124,0H31.1v2.376h3.567V21.229h2.812V11.072h3.567ZM69.8,8.3a4.524,4.524,0,0,0-4.868,4.889V21.23h2.781v-8.1a2.037,2.037,0,0,1,2.117-2.225,2.12,2.12,0,0,1,2.1,2.225v8.1h2.781V13.192A4.551,4.551,0,0,0,69.8,8.3ZM59.307,8.7V21.229h2.781V8.7Zm-9.433,4.965.09.56,2.615,7.008h1.134L57.266,8.7H54.53l-1.693,6.585-.106.711-.136-.711L50.327,8.7H49.42l-2.267,6.585-.136.711-.09-.711L45.233,8.7H42.482l3.553,12.534h1.134l2.615-7.008.09-.56",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.608,16.156,17.3,21l-1.686-2.585L17.562,15.5a3.811,3.811,0,0,0,.241-3.894,4.052,4.052,0,0,0-7.348,0,3.746,3.746,0,0,0,.223,3.843s1.084,1.586,1.979,2.929L14.12,20.5l2.2,3.378a1.273,1.273,0,0,0,.981.551,1.377,1.377,0,0,0,1-.586l5.162-7.651H20.608v-.034Zm-6.488.121s-.86-1.309-1.429-2.223a1.64,1.64,0,1,1,2.857,0C15,14.967,14.12,16.276,14.12,16.276Z",
    transform: "translate(0 -2.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.954,20.843,7.719,16.294s-.86-1.309-1.429-2.223a1.631,1.631,0,0,1,1.429-2.447,1.5,1.5,0,0,1,.482.069L9.336,9.608a4.114,4.114,0,0,0-1.6-.345,4.067,4.067,0,0,0-3.682,2.344,3.746,3.746,0,0,0,.223,3.843l5.662,8.392a1.334,1.334,0,0,0,1.015.6,1.288,1.288,0,0,0,1-.586l1.7-2.6L12.194,19.1l-1.239,1.74Z",
    transform: "translate(0 -2.101)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwint);
export default __webpack_public_path__ + "static/media/twint.d1d161eab3e695c26e65c1f1a793db00.svg";
export { ForwardRef as ReactComponent };